import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as PhantomImage } from '../../../images/errores/fantasma.svg';
import ContactCardInfo from './styles/ServiceErrorStyled';
import Button from '../Button';

const ServiceError = ({
  click,
  buttonColor,
  buttonOutline,
  buttonHeight,
  buttonText,
  textMaxWidth,
}) => (
  <>
    <PhantomImage height="90px" />
    <ContactCardInfo maxWidth={textMaxWidth}>
      Algo falló, no pudimos procesar tu solicitud, por favor reintenta
      nuevamente.
    </ContactCardInfo>
    <Button
      maxWidth="100%"
      color={buttonColor}
      outline={buttonOutline}
      margin="0 0 25px 0"
      height={buttonHeight}
      click={click}
    >
      {buttonText}
    </Button>
  </>
);

ServiceError.propTypes = {
  click: PropTypes.func.isRequired,
  buttonColor: PropTypes.oneOf(['purple', 'bubbleGum', 'white']),
  buttonOutline: PropTypes.bool,
  buttonHeight: PropTypes.string,
  buttonText: PropTypes.string,
  textMaxWidth: PropTypes.string,
};

ServiceError.defaultProps = {
  buttonColor: 'purple',
  buttonOutline: true,
  buttonHeight: '56px',
  buttonText: 'Reintentar',
  textMaxWidth: '200px',
};

export default ServiceError;
